<!-- 任务2 -->
<template>
  <div>
    <div class="course_Task2">
      <el-row
        style="border: 1px solid #D3D3D3;margin: 0 20px 20px 20px;padding: 0 20px 20px 20px;min-height: calc(100vh - 280px);"
      >
        <template v-if="examType == 2">
          <p
            style="background-color: rgb(239, 242, 247);margin: 0 -20px;color: #2789E2;padding: 20px;"
          >
            任务得分：10 分 学习时长：50分钟
          </p>
        </template>
        <p class="fontB">
          <i class="el-icon-document-remove icon_"></i>任务名称：
        </p>
        <p style="min-height: 21px;">{{ taskInfo.taskTitle }}</p>
        <p class="fontB">
          <i class="el-icon-s-data icon_" style="color: #8a39c2;"></i>任务分值：
        </p>
        <p style="min-height: 21px;">{{ taskInfo.taskScore }}分</p>
        <p class="fontB">
          <i class="el-icon-document-copy icon_"></i>考核内容：
        </p>
        <el-row class="aljj">
          <p>1、至少观看{{ taskInfo.assessmentRequirements }}分钟PPT</p>
          <p>2、每隔{{ taskInfo.assessmentTime }}分钟弹出一次验证框</p>
        </el-row>
        <p class="fontB">
          <i class="el-icon-edit-outline icon_" style="color: #2eb68e;"></i
          >考核任务：
        </p>
        <el-row>
          <el-col :span="10">
            <el-table
              border
              :data="tableData"
              style="width: calc(100% - 20px);"
            >
              <el-table-column
                type="index"
                header-align="center"
                align="center"
                width="100"
                label="序号"
              ></el-table-column>
              <el-table-column
                prop="fileName"
                header-align="center"
                align="center"
                label="PPT名称"
              ></el-table-column>
              <el-table-column
                prop="jd"
                header-align="center"
                align="center"
                label="进度"
                width="100"
              >
                <template slot-scope="scope">
                  <span style="color: #F83131;">{{ scope.row.jd || "-" }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="_"
                header-align="center"
                align="center"
                label="操作"
                width="120"
              >
                <template slot-scope="scope">
                  <el-link
                    type="primary"
                    :underline="false"
                    @click="seePpt(scope.row)"
                    >{{ scope.row.jd == 0 ? "观看" : "继续观看" }}</el-link
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="14">
            <el-row
              style="width: 100%;height: 600px;background-color:#E5E5E5;line-height: 300px;text-align: center;"
            >
              <iframe
                v-if="URLInfo"
                id="InformationURL"
                :src="URLInfo + '#toolbar=0'"
                width="100%"
                height="100%"
                frameborder="1"
              ></iframe>
              <p v-if="!URLInfo">PPT播放</p>
            </el-row>
          </el-col>
        </el-row>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "Task2",
  props: {
    examType: {
      //考试类型 1：考试 2：查看成绩
      type: String,
      default: function() {
        return 1;
      }
    },
    taskId: {
      //任务ID
      type: String,
      default: function() {
        return "";
      }
    }
  },
  data() {
    return {
      tableData: [],
      taskInfo: {}, //任务详情
      URLInfo: ""
    };
  },
  created() {
    this.getInfo();
  },
  mounted() {},
  methods: {
    getInfo() {
      //获取详情
      this.$get("/api/teacherOpenCourseHandsOnSimulationTasks/getInfo.do", {
        taskId: this.taskId
      }).then(ret => {
        if (ret.code == 0) {
          this.taskInfo = ret.data;
          this.tableData =
            ret.data.teacherOpenCourseHandsOnSimulationTasksFileList;
        } else {
          this.$message({ message: ret.msg, type: "error" });
        }
      });
    },
    seePpt(item) {
      //查看PPT
      this.URLInfo = this.$isHttp(item.fileUrl);
    }
  }
};
</script>
<style lang="less">
.course_Task2 {
  .icon_ {
    color: #2789e2;
    margin-right: 10px;
  }
  .has-gutter {
    th {
      border-color: #e5e5e5;
      background-color: #eff2f7;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Teacher/components/PracticalTraining/Task2.vue